export default __webpack_public_path__ + "static/media/404-bg.27e309d0.jpg";